const ACCESS_TOKEN = "access_token";
const AUTH_USER = "user";
const STATION_ID = "last_station_id";
const PLAYER_VOLUME = "player_volume";

export const getToken = () => {
    return window.localStorage.getItem(ACCESS_TOKEN);
};

export const saveToken = token => {
    window.localStorage.setItem(ACCESS_TOKEN, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ACCESS_TOKEN);
};

export const getUser = () => {
    return JSON.parse(window.localStorage.getItem(AUTH_USER));
};

export const saveUser = user => {
    window.localStorage.setItem(AUTH_USER, JSON.stringify(user));
};

export const destroyUser = () => {
    window.localStorage.removeItem(AUTH_USER);
};

export const destroy = () => {
    window.localStorage.removeItem(AUTH_USER);
    window.localStorage.removeItem(ACCESS_TOKEN);

};


export const getStationId = () => {
    return window.localStorage.getItem(STATION_ID);
};

export const saveStationId = stationId => {
    window.localStorage.setItem(STATION_ID, stationId);
};

export const removeStationId = () => {
    window.localStorage.removeItem(STATION_ID);
};

export const saveVolume = volume => {
    window.localStorage.setItem(PLAYER_VOLUME, volume);
};

export const getVolume = volume => {
    return parseInt(window.localStorage.getItem(PLAYER_VOLUME, volume));
};



export default { getToken, saveToken, destroyToken, getUser, saveUser, destroyUser, destroy, removeStationId };